const niceURL = require('./nice-url')
const conf = require('./conf')

const { webOutsidePort, webURL } = conf
module.exports = niceURL(webURL, webOutsidePort)
